import {
  ShopifyAjaxCartDataSchema,
  type ShopifyAjaxCartData,
} from "../../models/shopify/ajax-api/cart"

/**
 * Fetches the storefront cart via Shopify Cart AJAX API.
 * @param options - Request options.
 * @param options.storeOrigin - Shop origin including protocol (e.g. window.shopUrl).
 * @returns Parsed and validated cart payload.
 */
export async function getCart(options: { storeOrigin: string }): Promise<ShopifyAjaxCartData> {
  const base = options.storeOrigin.replace(/\/$/, "")
  const response = await fetch(`${base}/cart.js`, {
    method: "GET",
    headers: { Accept: "application/json" },
  })

  if (!response.ok) {
    throw new Error(`getCart failed: ${response.status}`)
  }

  const json: unknown = await response.json()
  return ShopifyAjaxCartDataSchema.parse(json)
}
